const navLinks = {
  "/projects": "menuLinks.projects",
  "/last-played-games": "menuLinks.lastPlayedGames",
  "/impressum": "impressumLink",
};

export default navLinks;
